if (!customElements.get('afterpay-installments')) {
  class AfterpayInstallments extends HTMLElement {
    constructor() {
      super();
      this._afterpayInited = false;
    }

    connectedCallback() {
      const run = () => this.initAfterpay();
      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run, { once: true });
      }
    }

    initAfterpay() {
      if (this._afterpayInited || !this.isConnected) return;
      if (typeof presentAfterpay === 'undefined') return;

      const amount = this.getAttribute('data-amount');
      if (!amount) return;

      this._afterpayInited = true;

      new presentAfterpay({
        afterpayLogoColor: 'color',
        priceSelector: 'afterpay-installments .afterpay--append',
        locale: 'en_US',
        amount,
        showUpperLimit: false,
        minMaxThreshold: { min: 100, max: 100000 },
        mutationObserver: null,
      }).init();
    }
  }

  customElements.define('afterpay-installments', AfterpayInstallments);
}